import React from "react";
import { useLocation } from "react-router-dom";

import { cn } from "@/lib/helpers/cn";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { useFilterPermittedItems } from "@/features/access-control/hooks/useFilterPermittedItems";

import { NavMenuItem } from "../../NavMenuItem/NavMenuItem";
import "../../NavMenuItem/styles.scss";

export function RouteSection(props) {
  const { config, handleClickSearch, isSearchOpen, messageCount = 0 } = props;
  const location = useLocation();

  const filteredOptions = useFilterPermittedItems(config.options);

  const options = filteredOptions.map((option) => {
    if (option.mobileOnly) {
      return null;
    }

    if (option.label === "Search") {
      return (
        <li
          key={option.label}
          onClick={handleClickSearch}
          {...getAutomationDataAttr(`NavMenuItem_${option.label}`)}
        >
          <a
            className={cn(
              "tw:relative tw:flex tw:items-center tw:justify-center tw:gap-1",
              "tw:max-lg:flex-col tw:max-lg:text-xxs",
              "text-nowrap tw:fill-fill-white tw:text-text-white tw:no-underline",
              "tw:hover:fill-fill-teal-secondary tw:hover:text-text-teal-secondary",
              "tw:text-[15px] tw:transition-none",
              "tw:cursor-pointer",
              isSearchOpen && "tw:fill-fill-teal-secondary tw:text-text-teal-secondary",
            )}
          >
            {option.iconComponent}
            <span className="NavMenuLabelWrapper trim-both">{option.label}</span>
          </a>
        </li>
      );
    }

    if (option.iconComponent) {
      return (
        <NavMenuItem key={option.label} route={option.route} testId={`NavMenuItem_${option.label}`}>
          {location.pathname.includes(option.route)
            ? option.activeIconComponent
            : option.iconComponent}

          <span className="NavMenuLabelWrapper trim-both">{option.label}</span>

          {messageCount > 0 && option.label === "Messages" && (
            <div className="messagesNotification"></div>
          )}
        </NavMenuItem>
      );
    } else if (option.icon) {
      return (
        <NavMenuItem key={option.label} route={option.route}>
          <span alt="" className={"mr-2 " + option.icon}></span>
          {option.label}
        </NavMenuItem>
      );
    } else {
      return (
        <NavMenuItem key={option.label} route={option.route}>
          {option.label}
        </NavMenuItem>
      );
    }
  });

  return (
    <ul
      className="tw:flex tw:w-full tw:items-center tw:justify-between"
      {...getAutomationDataAttr("main-navigation-item-list")}
    >
      {options}

      {/* spacing hack, should refactor to grid someday */}
      <li />
    </ul>
  );
}
